import * as R from "ramda";

import ContentListingItem from "./ContentListingItem.jsx";
import { array } from "prop-types";

const propTypes = { results: array };

const VariantThree = (props) => {
  const { results } = props;

  const splitResults = R.splitAt(1, results ? results : []);

  const first = splitResults && splitResults[0] && splitResults[0][0];
  const rest = splitResults && splitResults[1];

  return (
    <div className="dynamic-content-listing__variant-three">
      <div className="dynamic-content-listing__first-result">
        {first && (
          <ContentListingItem
            displayImage={true}
            {...first}
            isFirst={true}
            variantType={3}
          />
        )}
      </div>
      <div className="dynamic-content-listing__results-row--three-up">
        {rest?.map((item, i) => (
          <ContentListingItem
            key={i}
            displayImage={true}
            {...item}
            variantType={3}
          />
        ))}
      </div>
    </div>
  );
};

VariantThree.propTypes = propTypes;
export default VariantThree;
